import ThemeModal from './components/modals/ThemeModal'

export default function () {
  return { component: ThemeModal }
}
